import { placeMap } from '@/api';
import { post } from '@/common/request';

export interface SearchParams extends City {
  placeName?: string;
  placeCategoryIdList?: number[];
  placeLabelIdList?: number[];
  constructionTimeRange?: Range;
  placeAreaRange?: Range;
  spotCountRange?: Range
  supplyCountRange?: Range
}

export interface City {
  provinceIdList?: number[];
  cityIdList?: number[];
  districtIdList?: number[];
}

export interface Range {
  maxValue?: number,
  minValue?: number
}

export interface PlaceInfo {
  tenantPlaceId?: number,
  placeName?: string,
  address?: string,
  categoryId?: number,
  categoryName?: string,
  area?: number;
  constructionTime?: number,
  spotCounr?: number,
  supplierCount?: number;
  buildingLevel?: string
  builtArea?: number,
  businessCircle?: string
  workdayDayAvg?: number;
  placeDescription?: string;
  placeLabelList?: Label[];
  panorama?: File[];
  placePicture?: File[];
  placeVideo?: File[];
  floorPlan?: File[];
  topPropertyList?: any[];
  placeAnalysisTop?: any;
  placePublicId?: number;
}

export interface File {
  name?: string;
 type?: string;
 url?: string;
}

export interface Label {
    tenantPlaceId?: number,
    tenantLabelId?: number,
    labelName?: string,
    reviewStatus: 1 | 2|3
}

interface Response {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectList?: PlaceInfo[]
}

export interface CreateInfo {
  placeName: string,
  placeCategoryId: number,
  area: {
    provinceId: number,
    cityId: number,
    districtId: number
  },
  address: {
    address: string,
    longitude: number,
    latitude: number,
    poiId: number,
    poiName: number
  }
}

export interface Group {
  groupId?: string;
  groupName?:	string;
  propertyList?: Property[];
  propertyGroupConfig?: PropertyValue
}

export interface Property {
  controlType?:	number;
  propertyName?:	string;
  value?: string;
  propertyId?: number;
  propertyValueOptionList?: any[];
  textValue?: any;
  columns?: { title: string, dataIndex: string }[]
}

interface Respone {
  resourceGroupList?: Group[];
  placeBasicInfo?: PlaceInfo;
  permissions?: any[];
  onShelvesStatus?: number;
}


export interface DetailInfo extends PlaceInfo {
  propertyValueList: PropertyValue[];
  resourcesType: string;

}

export interface PropertyValueEdit {
  propertyId: number;
  textValue?: any;
}

export interface PropertyValue extends PropertyValueEdit {
 categoryPropertyGroupId?: number;
 categoryPropertyGroupConfigId?: number;
 categoryPropertyGroupConfigIdentification?: string;
 controlType?: number;
 propertyValueOptionList?: any[];
}

interface SpotInfo {
  id?: string;
  spotFloor?:	string;
  categoryName?: string;
  spotPosition?: string;
  spotArea?: string
}

interface VisitRecoder {
    id?: number,
    tenantPlaceId?: number,
    supplierId?: number,
    person?: number,
    visitDate?: string,
    visitType?: number,
    otherType?: string,
    employeeId: 100000,
    employeeName?: string,
    entourageEmployeeId: 100000,
    entourageEmployeeName?: number,
    fileContent: [],
    remark?: string,
    longitude?: number,
    latitude?: number,
    address?: string,
    firstVisit?: number
}

interface Tabs {
  tntResourceId?: number,
  resourceType?: number,
  name?: string,
  checked?: boolean;
}


// 请不要再往这里塞api，用规范写法，不懂就问！
class PlaceStore {
  getResList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
    return post(placeMap.get('resList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  add(info: CreateInfo): Promise<any> {
    return post(placeMap.get('add'), info, { needHint: true });
  }

  copyByRes(placeIdList: number[]): Promise<boolean> {
    return post(placeMap.get('copy'), { placeIdList }, { proxyApi: '/resserv', needHint: true });
  }

  getInfoBytenantPlaceId(tenantPlaceId: number): Promise<DetailInfo> {
    return post(placeMap.get('detail'), { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
  }

  getAnalysisBytenantPlaceId(tenantPlaceId: number): Promise<Respone> {
    return post(placeMap.get('analysis'), { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
  }

  getPlaceEamineOrderDetailBytenantPlaceId(tenantPlaceId: number): Promise<Respone> {
    return post(placeMap.get('placeEamineOrderDetail'), { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
  }

  edit(params): Promise<boolean> {
    return post(placeMap.get('edit'), params, { needHint: true });
  }

  getSpotList(tenantPlaceId: number): Promise<SpotInfo[]> {
    return post(placeMap.get('spotList'), { tenantPlaceId }, { proxyApi: '/resserv', needHint: true });
  }

  getVisitRecoderList(page: number, size: number, options?: {tenantPlaceId: number}): Promise<{pageSize?: number, pgaeNum?: number, objectList?: VisitRecoder[]}> {
    return post(placeMap.get('visitRecoderList'), { ...options, page, size }, { proxyApi: '/resserv', needHint: true });
  }

  getTabList (resourceType: 0| 1, tntResourceId: number): Promise<Tabs[]> {
    return post(placeMap.get('tabList'), { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
  }
}

export default new PlaceStore();
